import { render, staticRenderFns } from "./aRoomDetailOwner.vue?vue&type=template&id=64b19c60&scoped=true"
import script from "./aRoomDetailOwner.vue?vue&type=script&lang=js"
export * from "./aRoomDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailOwner.vue?vue&type=style&index=0&id=64b19c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b19c60",
  null
  
)

export default component.exports